<template>
  <div class="w-full">
    <NText class="pr-2" variant="caption1" weight="medium">
      {{ confirmMessage }}
    </NText>

    <div class="flex items-center justify-center mt-6">
      <NButton
        class="ml-3 flex-1"
        color="gray"
        variant="flat"
        @click="remove()"
      >
        {{ t('common.cancel') }}
      </NButton>

      <NButton
        v-gid="{
          module: 'portfolio',
          screen: 'home',
          section: 'deleteVirtualPortfolioDialog',
          component: 'deleteButton',
        }"
        color="red"
        class="mr-3 flex-1"
        @click="emit('delete')"
      >
        {{ t('misc.delete') }}
      </NButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useDialog } from '@negar/core';

type ConfirmDeleteDialogEmitsType = {
  (e: 'delete'): void;
};

type ConfirmDeleteDialogPropsType = {
  confirmMessage: string;
};

const emit = defineEmits<ConfirmDeleteDialogEmitsType>();
defineProps<ConfirmDeleteDialogPropsType>();

const { remove } = useDialog();

const { t } = useI18n();
</script>
